import React, { Component } from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
// import Navbar from 'react-bootstrap/Navbar';
// import Nav from 'react-bootstrap/Nav';
import './assets/css/style.css';
import './assets/css/font-awesome.min.css'
import './assets/css/ie9.css'
import './assets/css/main.css'
// import { Route, NavLink, HashRouter, Redirect } from 'react-router-dom';
// import Home from './Home';
// import Events from './Events'
// import About from './About'
// import Join from './Join'
import dscLogo from './assets/images/portland_state_dsc_logo.png'

// import Container from 'react-bootstrap/Container'

class Main extends Component {
    render() {
        return (
            <div>

                {/* <!-- Banner --> */}
                <section>
                    <div className="wrapper-inner-banner">
                        <div className="header">
                            <a href="https://dsc.community.dev/portland-state-university/#upcoming-events">Events</a>
                            <a href="https://dsc.community.dev/portland-state-university/#team-list">About Us</a>
                        </div>
                        <div className="fill">
                            <img src={dscLogo} alt="Developer Student Club Portland State University."></img>
                        </div>
                    </div>
                </section>

                {/* information about DSC */}

                <section>

                    <div className="wrapper-light">
                        <div className="wrapper-inner">
                            <div className="wrapper-video">
                                <iframe src="https://www.youtube.com/embed/5qUKo0kp-cE" title="DSC info video"
                                    frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                            <p>
                            Portland State DSC is a student run community to help undergraduate and graduate students develop solutions to real-world problems. With the help of Google, we have access to some of the best learning resources, mentors, and technology available. All majors are welcome!
                            </p>
                        </div>
                    </div>
                </section>

                {/* <!-- One --> */}
                <div className="wrapper-light">
                <section id="one">
                    <div className="inner">
                        <div className="features">
                            <div className="feature">
                                <i className="fa fa-laptop fa-3x"></i>
                                <h3>Learn</h3>
                                {/* <p>Operation leads are the core component of our team’s success- they handle the administrative work that we rely on for the success of our events and programs.</p> */}
                            </div>
                            <div className="feature">
                                <i className="fa fa-users fa-3x"></i>
                                <h3>Connect</h3>
                                {/* <p>Marketing leads are how we connect with our audience- from students who want to grow as a developer to students who want to learn to code, marketing leads help spread our mission and make our events accessible to students across our university.</p> */}
                            </div>
                            <div className="feature">
                                <i className="fa fa-globe fa-3x"></i>
                                <h3>Create</h3>
                                {/* <p>Technical leads are the facilitators for our technical events and mentors for the Google Solution challenge. They are passionate about helping members grow as developers and are ready to help when students have questions.</p> */}
                            </div>
                        </div>
                    </div>
                </section>
                </div>

                <div className="wrapper-light">
                    <div className="wrapper-inner">
                        <a href="https://forms.gle/LorZWBVTx8LeB2e36">Join Today</a>


                    </div>
                </div>

                {/*footer*/}

                <footer id="footer">
                    <div className="wrapper-dark">
                    <div className="bottom-round">
                        <div className="notice">Interested in becoming a core team member? <a href="https://forms.gle/JadkFAimrEJe6NXN9">Sign Up!</a></div>
                    </div>
                    </div>

                            <div className="dsc-email">
                                <a href="mailto:gdsc.2020.2021.pdx@gmail.com">gdsc.2020.2021.pdx@gmail.com</a>
                            </div>
                            <div className="social-list">
                    <span>
                        <a href="https://www.facebook.com/groups/pdxgdsc">
                            <i className="fa fa-facebook social-icon"></i>
                        </a>
                        <a href="https://www.youtube.com/channel/UCezidN7FFVpQ9BtKVndLDew?view_as=subscriber">
                            <i className="fa fa-youtube social-icon"></i>
                        </a>
                        <a href="https://www.instagram.com/psu_dsc/">
                            <i className="fa fa-instagram social-icon"></i>
                        </a>
                        <a href="https://www.linkedin.com/groups/13901007/">
                            <i className="fa fa-linkedin social-icon"></i>
                        </a>
                        <a href="http://psu-dsc.slack.com">
                            <i className="fa fa-slack social-icon"></i>
                        </a>
                        </span>
                    </div>
                    {/* <div className="copyright"> &copy; Designed By Michael Scherrer </div> */}
                </footer>


            </div>
        );
    }
}

export default Main;